/*****************************************************************************************************************************************************
 * Revision History
 * 2024-08-22 TBH - Changed bindCartList() to bindAddCartList() then made new bindCartList() that calls bindAddCartList() and bindWaitCartList() methods.
 * 2024-09-05 TBH - Bug fix. JavaScript fetch is asynchronous so bindAddCartList() has to call  bindWaitCartList() in its final ".then" statement.
 *****************************************************************************************************************************************************/

import { OlliCartFeeSummaryUrl, OlliCoursesUrl, APIDownError, OlliMembershipOptionUrl, OlliCartUrl, CartProfileUpdateUrl, LoginUrl } from "../directives/utilities/urls";
export default function olliCartList() {
  return {    
    showErrorMesage: "",
    showSuccessMesage: "",
    enrollmentCartList: [],
    waitlistCartList: [],
    membershipOptionList:[],
    selectedItem:[],   
    showLoader: false,
    isSubmitting:false,
    message: '',
    remainingCartCount: 0,
    olliCourse: OlliCoursesUrl,

    formatDate( dateValue ) {
      const formattedDate = new Date(dateValue).toLocaleDateString();
      return formattedDate;
      },      

    showRemoveCartList( item ) {
      this.selectedItem = item;
      document.getElementById("btnDelete").click();
      },

    removeCartList( item ) {
// console.log.log( 'removeCartList()' );
      var jsonData = JSON.stringify({
        "UserSessionId": "",
        "AcademicYear": this.selectedItem.academicYear,
        "AcademicTerm": this.selectedItem.academicTerm,
        "AcademicSession": this.selectedItem.academicSession,
        "SerialId": this.selectedItem.serialId
        });
// console.log.log( jsonData );
      this.showLoader = true;

      fetch("/api/Checkout/delete-course-from-cart", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          },
        body: jsonData,
        })
      .then((response) => {
        return response.json();
        })
      .then((response) => {
        this.showLoader = false;
        if( response != undefined && response.isSuccess ) {
          this.showSuccessMesage = "Course removed succesfully."
          this.remainingCartCount = response.remainingCartCount;

          document.getElementById('cartPathAnchor').href = OlliCartUrl;
          document.getElementById('cartCountSpan').textContent = this.remainingCartCount;
          document.getElementById('cartPathAnchorMobile').href = OlliCartUrl;
          document.getElementById('cartCountSpanMobile').textContent = this.remainingCartCount;

          this.bindCartLists();
          } 
        else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later.";
// console.log.log( 'removeCartList() - Error' );
          }
        });
      },

    GetCheckoutMembershipOption() {
            fetch('/api/OlliCheckout/GetCheckoutMembershipOption', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                 
                    if (response != undefined && response.isSuccess) {
                        this.membershipOptionList = response.membershipOption;
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
// console.log.log( 'GetCheckoutMembershipOption() - Error' );
                    }

                });
        },

    bindLoadMembershipList() {

      let jsonData = JSON.stringify({
        //"AcademicYear": parseInt(urlParams.get('MembershipAcademicYear')),
        //"AcademicTerm": urlParams.get('MembershipAcademicTerm'),
        });
      fetch('/api/OlliCheckout/LoadMembership', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          },
        body: jsonData
        })
      .then( response => {
        if( response.ok ) {
          return response.json()
          }
        })
      .then( response => {
        if( response != undefined && response.isSuccess ) {
          if( response.redirectToCheckout ) {
            this.bindCartLists();
            } 
          else if( response.showMembershipOptions ) {
            window.location.href = OlliMembershipOptionUrl;
            }
          } 
        else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
// console.log.log( 'bindLoadMembershipList() - Error' );
          }
        });
      },

    bindCartLists() {
// console.log.log( "bindAddCartList()" );
      var jsonData = JSON.stringify({
        SessionId: "",
        RequestType: 1
        });

      this.showLoader = true;
      this.enrollmentCartList = [];
      fetch("/api/OlliCheckout/GetOLLICheckOutCartCourse", {
        method: "POST",
        headers: { 
          Accept: "application/json",
          "Content-Type": "application/json",
          },
        body: jsonData,
        })
      .then((response) => {
        return response.json();
        })
      .then((response) => {
        this.showLoader = false;
        if( response != undefined && response.isSuccess ) {
// console.log.log( 'ADD Cart: ' + JSON.stringify( response ));
          if( response.cartItems.length > 0 ) {                           
            this.enrollmentCartList = response.cartItems;
            this.showErrorMesage = "";
            } 
          this.bindWaitCartList();
          } 
        else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later.";
// console.log.log( 'bindCartLists() - Error'  );
          }
        });
      },

    bindWaitCartList() {
// console.log.log( "bindWaitCartList()" );
      var jsonData = JSON.stringify({
        SessionId: "",
        RequestType: 2
        });

      this.showLoader = true;
      this.waitlistCartList = [];
    
      fetch("/api/OlliCheckout/GetOLLICheckOutCartCourse", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          },
        body: jsonData,
        })
      .then((response) => {
        return response.json();
        })
      .then((response) => {
        this.showLoader = false;
        if( response != undefined && response.isSuccess ) {
// console.log.log( 'WAIT Cart: ' + JSON.stringify( response ));
          if( response.cartItems.length > 0 ) {
            this.waitlistCartList = response.cartItems;   
            // Was "this.waitlistCartList.push( response.cartItems );" Think this set this.waitlistCartList to array of array cartItems rather than array of cartItems.
            this.showErrorMesage = "";
            } 

          if( this.waitlistCartList.length <= 0 && this.enrollmentCartList.length <= 0 ) {
// console.log.log( 'redirect to: ' + OlliCoursesUrl );
            window.location.href = OlliCoursesUrl;
            } 
          } 
        else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later.";
// console.log.log( 'bindWaitCartList() - Error' );
          }
        });
      },

    nextStep() {
      this.isSubmitting = true;
      fetch('/api/OlliCheckout/CompleteCart', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
          }
        })
      .then(response => {
        this.isSubmitting = false;
        return response.json();
        }).then(result => {
              
      if (result.isSuccess && result.allowCompletion) {              
        document.location.href = CartProfileUpdateUrl;                   
        }
      else if( result.isSuccess && result.showOlliEnrollmentCapMessage ) {
        this.message = result.message;
        } 
      else if( !result.isSuccess && result.isNotLoggedUser ) {
        document.location.href = LoginUrl;
        }
      else {
        this.message = result.messages.length > 0 
          ? result.messages.join( ', ' ) 
          : ( result.message != null ? result.message : APIDownError );
          }
        })
      },

    init() {
      this.GetCheckoutMembershipOption();
      this.bindLoadMembershipList();
      }
    };
  }
